import { render } from "./TeamsBlock.vue?vue&type=template&id=1f8c31d7&scoped=true"
import script from "./TeamsBlock.vue?vue&type=script&lang=js"
export * from "./TeamsBlock.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./TeamsBlock.vue?vue&type=style&index=1&id=1f8c31d7&lang=css"
import "./TeamsBlock.vue?vue&type=style&index=2&id=1f8c31d7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8c31d7"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSpinnerCube from 'quasar/src/components/spinner/QSpinnerCube.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTd,QPopupEdit,QInput,QToggle,QBtn,QCheckbox,QSpinnerCube});qInstall(script, 'directives', {Ripple});
